@import 'shared/design-system/style.scss';

.login_page__container {
  position: relative;
  padding-bottom: 240px;
  min-height: 99vh;
  background: url('/images/svg/bg_boxes.svg') no-repeat
      bottom,
    linear-gradient(
      180deg,
      rgba(235, 246, 229, 0) 11.04%,
      #ebf6e5 46.96%,
      #ebf6e5 57.83%,
      #ebf6e5 82.39%,
      rgba(235, 246, 229, 0) 100%
    ); /* W3C */
  background-attachment: fixed;
  background-size: contain;
}

.ghost_login_wrapper {
  text-align: center;
  .ghost_login {
    opacity: 0.2;
    cursor: default;
    color: #ebf6e5;
    display: inline-block;
  }
}

.logo__wrapper {
  padding: $spacer-extra-large;
  @include breakpoint-larger-than-small {
    padding: ($spacer-extra-large * 2);
  }
}

.logo {
  margin: 0 auto;
  width: 80%;
  // height: 72px;
  background: url('/images/svg/logo_primary.svg') no-repeat;
  background-size: contain;
  @include breakpoint-larger-than-small {
    width: 368px;
    height: 72px;
  }
}

.link {
  color: $cta-primary;
  cursor: pointer;
}

.login__wrapper {
  width: 80%;
  margin: 0 auto;
  padding: $spacer-extra-large;
  background-color: $white-base;
  border-radius: 4px;
  box-shadow: 0px 0px 22px rgba(0, 0, 0, 0.1);
  @include breakpoint-larger-than-small {
    width: 490px;
  }
  .label__wrapper {
    text-align: center;
    margin-bottom: $spacer-extra-large;
  }
  h1 {
    @include heading-page;
    margin: 0 auto $spacer-medium;
  }
  .role_type {
    @include heading-subheading;
    text-align: center;
    margin-bottom: $spacer-small;
  }
  .password {
    margin: 8px 0 $spacer-medium;
    text-align: center;
  }
  .submit {
    margin: 0 0 $spacer-medium;
    &:hover {
      background-color: purple;
    }
  }
  .forgot {
    cursor: pointer;
    color: $cta-primary;
    text-align: center;
  }
}

.button__group {
  text-align: center;
  display: flex;
  gap: $spacer-small;
  flex-direction: column;
}

.password_instructions {
  background-color: $grey-base;
  padding: $spacer-medium;
  display: flex;
  flex-direction: column;
  gap: $spacer-tiny;
  height: 0;
  opacity: 0;
  @include transition-base(all, 0.15s);
  &.active {
    height: auto;
    opacity: 1;
  }
}

.intro {
  margin-bottom: $spacer-tiny;
}

.instructions_item {
  display: flex;
  gap: $spacer-small;
  // align-items: center;
  svg {
    padding: 4px $spacer-tiny;
  }
}
.error {
  color: $critical;
}
